import { render, staticRenderFns } from "./ProductsDropDown.vue?vue&type=template&id=28a7f5fe"
import script from "./ProductsDropDown.vue?vue&type=script&lang=js"
export * from "./ProductsDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports